import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as d3 from 'd3';
import ChartTooltip from '../ChartTooltip';
import './style.css';

const svgHeight = 40;
const svgAxisWidth = 500;
const svgAxisHeight = 10;

class PercentageChart extends Component {
  static propTypes = {
    componentId: PropTypes.string.isRequired,
    values: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      start: PropTypes.number.isRequired,
      percentage: PropTypes.number.isRequired,
      color: PropTypes.string.isRequired,
      hoverParams: PropTypes.object,
    })).isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      hoverLeft: '',
      hoverParams: {},
    };
  }

  componentDidMount() {
    const { componentId, values } = this.props;
    const svgContainer = d3.select(`#percentagechart-${componentId}`)
      .append('svg')
      .attr('height', svgHeight)
      .attr('width', '100%');

    d3.select(`#percentagechart-${componentId}`)
      .append('div');

    svgContainer.append('rect')
      .attr('x', 0)
      .attr('y', 0)
      .attr('width', '100%')
      .attr('height', svgHeight)
      .attr('fill', 'white')
      .attr('stroke', 'grey')
      .attr('stroke-width', 1);

    svgContainer.selectAll('g')
      .data(values)
      .enter()
      .append('rect')
      .attr('x', d => `${d.start}%`)
      .attr('y', 0)
      .attr('width', d => `${d.percentage}%`)
      .attr('height', svgHeight)
      .attr('fill', d => d.color)
      .on('mouseover', (d) => {
        const rectNodePercentage = parseFloat(svgContainer.style('width').replace(/px/, ''), 10) / 100;
        const valueInPixels = (d.start * rectNodePercentage) + (d.percentage * rectNodePercentage / 2);
        this.setState({
          hoverLeft: `calc(${valueInPixels}px - 7.5%)`, // NOTE: 7.5% is half of the tooltip size, defined in CSS
          hoverParams: { ...d.hoverParams },
        });
      })
      .on('mouseout', () => {
        this.setState({ hoverLeft: '' });
      });

    const axisScale = d3.scaleLinear()
      .domain([0, 1])
      .range([0, svgAxisWidth - 1]);

    const axis = d3.axisBottom(axisScale)
      .ticks(5, '');

    d3.select(`#percentagechart-${componentId}-axis`)
      .append('svg')
      .attr('viewBox', `0 0 ${svgAxisWidth} ${svgAxisHeight}`)
      .append('g')
      .attr('height', svgAxisHeight)
      .call(axis)
      .selectAll('text')
      .remove();
  }

  render() {
    const { componentId } = this.props;
    const { hoverLeft, hoverParams } = this.state;

    return (
      <div>
        <div id={`percentagechart-${componentId}`} style={{ lineHeight: '0px' }} />
        <div className="percentagechart-bars">
          <div id={`percentagechart-${componentId}-axis`} style={{ lineHeight: '0px' }} />
          <div className="percentagechart-labels">
            <span>0%</span>
            <span>20%</span>
            <span>40%</span>
            <span>60%</span>
            <span>80%</span>
            <span>100%</span>
          </div>
        </div>
        {hoverLeft.length > 0 && <ChartTooltip marginLeft={hoverLeft} params={hoverParams} />}
      </div>
    );
  }
}

export default PercentageChart;



// WEBPACK FOOTER //
// ./src/components/reusable/PercentageChart/PercentageChart.js